"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputWithPrefix = exports.Input = void 0;
var _react = _interopRequireDefault(require("react"));
var _withPrefixLabel = require("../decorators/withPrefixLabel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Input = exports.Input = function Input(props) {
  return /*#__PURE__*/_react["default"].createElement("input", props);
};
var InputWithPrefix = exports.InputWithPrefix = (0, _withPrefixLabel.withPrefixLabel)(Input);